import request from '@/utils/request'

export const ME_ACCESS_PATH = '/api/v2/me/access'

// The access snapshot is deliberately not cached by the browser. It represents
// the current session and is reloaded after every full page refresh or login.
export function getMyAccess () {
  return request({
    url: ME_ACCESS_PATH,
    method: 'get',
    timeout: 12000,
    suppressErrorMessage: true
  })
}



// WEBPACK FOOTER //
// ./src/api/access.js